import { types } from "../../types/types";
import { areas } from "../../helpers/areas";
import { estados } from "../../helpers/estados";
import { fetchConToken } from "../../helpers/fetch";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { prepareBeneficiarios } from "../../helpers/prepareBeneficiarios";
import { startAlerta } from "../ui/alertas";
import { fetchGrupoFamiliarPreinscripto } from "../grupoFamiliarPreinscripto";
import { changeStepper } from "./stepper";
import {
  fetchDocumentacionAfiliacion,
  fetchDocumentacionStageAfiliacion,
  fetchDocumentacionStageFamiliarAfiliacion,
  limpiarListaDocumentacionAfiliado,
} from "../documentaciones/documentacion";
import { empresasPreafiliadoLimpiar } from "../empresasPreafiliado";
import { grupoFamiliarSetTab, seleccionFamiliarAfiliado, seleccionFamiliarPreinscripto, seleccionFamiliarPreinscriptoStage } from "../familiarSeleccionado";
import { fetchAportesPreafiliado } from "../aportesPreafiliado";
import { tomarPreAfiliacion } from "../preafiliacionesTomadas";
import { fetchGrupoFamiliar, fetchGrupoFamiliarAfiliadoPreinscriptoStage } from "../grupoFamiliar";
import { agregarNotificacion } from "../notificaciones";

const urlBase = process.env.REACT_APP_URL
const urlBaseApp = process.env.REACT_APP_URL_BASE
export const traerAfliadoPorCuil = (cuil) => async (dispatch, getState) => {
  try {
    dispatch(desSeleccionarAfiliadoNuevo());
    dispatch(startSpinner());
    dispatch(limpiarListaDocumentacionAfiliado());
    dispatch(empresasPreafiliadoLimpiar());
    dispatch(fetchAportesPreafiliado(cuil));
    const response = await fetchConToken(
      `Preafiliados/traerDesdeServicio/${cuil}`
    );

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      
      const afiliado = await response.json();
      if (response.status !== 200) throw afiliado.errores;
      afiliado.cuil = cuil;

      const state = getState();
      const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
      const { idUsuario } = state.auth;
      // Si soy usuario Seccional     AREA 1
      // Dos acciones. Evaluar o crear nuevas
      // Si evaluo ,veo 10, 11, 19, 29
      // Si es nueva debe ser 0 y la guardo coo 8/9
      // Si el estado == 1 la afiliacion es online y todavia no puede modificarse

      // Si soy usuario Nacional      AREA 2
      // Solo Evaluo en estado 20, 21, 29.     Estado 30 ya son aprobadas y deberán verse en modificar solamente.
      if (afiliado.estado === estados.Preafiliacion_NuevoOnline) {
        console.log("primer entrada");
        dispatch(
          startAlerta(
            "Pre Afiliación Online. Todavia no puede modificarse.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        idAreaUsuario === areas.Nacional &&
        afiliado.estado === estados.Preafiliacion_BandejaNacionalObservada
      ) {
        dispatch(
          startAlerta(
            "La Pre Afiliación se encuentra en revisión por Seccional. Aguarde por favor.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (afiliado.estado === estados.Preafiliacion_BandejaNacionalAprobada) {
        dispatch(
          startAlerta(
            "El cuil ingresado corresponde a un afiliado activo.",
            "success",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        (idAreaUsuario === areas.Seccional &&
          afiliado.estado !== estados.Preafiliacion_Inicial &&
          afiliado.estado !== estados.Preafiliacion_PresencialNuevo &&
          afiliado.estado !== estados.Preafiliacion_BandejaSeccional &&
          afiliado.estado !==
          estados.Preafiliacion_BandejaSeccionalModificada &&
          afiliado.estado !== estados.Preafiliacion_BandejaSeccionalObservada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalObservada) ||
        (idAreaUsuario === areas.Nacional &&
          afiliado.estado !== estados.Preafiliacion_Inicial &&
          afiliado.estado !== estados.Preafiliacion_PresencialIngresada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacional &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalModificada)
      ) {
        dispatch(
          startAlerta(
            "Pre Afiliación en Evaluación. Aguarde por favor.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        afiliado.estado === estados.Preafiliacion_BandejaSeccionalObservada ||
        afiliado.estado === estados.Preafiliacion_BandejaSeccionalModificada ||
        afiliado.estado === estados.Preafiliacion_BandejaSeccional ||
        afiliado.estado === estados.Preafiliacion_BandejaNacional ||
        afiliado.estado === estados.Preafiliacion_PresencialIngresada ||
        afiliado.estado === estados.Preafiliacion_BandejaNacionalModificada ||
        afiliado.estado === estados.Preafiliacion_BandejaNacionalObservada
      ) {
        dispatch(
          startAlerta("Dirigirse a bandeja por favor.", "warning", `¡Atención!`)
        );
        dispatch(changeStepper(0));
      } else {
        if (afiliado.estado > 8)
          dispatch(tomarPreAfiliacion(idUsuario, afiliado));
        else
          dispatch({
            type: types.consultaTraerAfiliadoPorCuil,
            payload: afiliado,
          });
      }
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    err.mensaje !== undefined ? dispatch(startAlerta(err.mensaje, "warning", `¡Error!`)) : dispatch(startAlerta(err.Msg, err.Type, err.Title));
    dispatch(changeStepper(0));
  }
};

export const traerAfliadoPorCuilBandeja = (cuil, idGrupoFamiliar = null) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(desSeleccionarAfiliadoNuevo());
    dispatch(startSpinner());
    dispatch(limpiarListaDocumentacionAfiliado());
    dispatch(empresasPreafiliadoLimpiar());
    dispatch(fetchAportesPreafiliado(cuil));
    const response = await fetchConToken(
      idGrupoFamiliar ? `Preafiliados/traerDesdeServicio/${cuil}/${idGrupoFamiliar}` : `Preafiliados/traerDesdeServicio/${cuil}`
    );
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const afiliado = await response.json();
      if (response.status !== 200) throw afiliado.errores;
      afiliado.cuil = cuil;

      const state = getState();
      const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
      const { idUsuario } = state.auth;

      // Si soy usuario Seccional     AREA 1
      // Dos acciones. Evaluar o crear nuevas
      // Si evaluo ,veo 10, 11, 19, 29
      // Si es nueva debe ser 0 y la guardo coo 8/9
      // Si el estado == 1 la afiliacion es online y todavia no puede modificarse

      // Si soy usuario Nacional      AREA 2
      // Solo Evaluo en estado 20, 21, 29.     Estado 30 ya son aprobadas y deberán verse en modificar solamente.
      if (afiliado.estado === estados.Preafiliacion_NuevoOnline) {
        console.log("primer entrada");
        dispatch(
          startAlerta(
            "Pre Afiliación Online. Todavia no puede modificarse.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        idAreaUsuario === areas.Nacional &&
        afiliado.estado === estados.Preafiliacion_BandejaNacionalObservada
      ) {
        dispatch(
          startAlerta(
            "La Pre Afiliación se encuentra en revisión por Seccional. Aguarde por favor.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        (idAreaUsuario === areas.Seccional &&
          afiliado.estado !== estados.Preafiliacion_Inicial &&
          afiliado.estado !== estados.Preafiliacion_PresencialNuevo &&
          afiliado.estado !== estados.Preafiliacion_BandejaSeccional &&
          afiliado.estado !==
          estados.Preafiliacion_BandejaSeccionalModificada &&
          afiliado.estado !== estados.Preafiliacion_BandejaSeccionalObservada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalObservada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalAprobada) ||
        (idAreaUsuario === areas.Nacional &&
          afiliado.estado !== estados.Preafiliacion_Inicial &&
          afiliado.estado !== estados.Preafiliacion_PresencialIngresada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacional &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalModificada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalAprobada)
      ) {
        dispatch(
          startAlerta(
            "Pre Afiliación en Evaluación. Aguarde por favor.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else {
        // dispatch({
        //   type: types.consultaTraerAfiliadoPorCuil,
        //   payload: afiliado,
        // });
        //console.log("desdeBandeja");
        dispatch(tomarPreAfiliacion(idUsuario, afiliado));
      }
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    err.mensaje !== undefined ? dispatch(startAlerta(err.mensaje, "warning", `¡Error!`)) : dispatch(startAlerta(err.Msg, err.Type, err.Title));
    dispatch(changeStepper(0));
  }
};

export const traerAfliadoPorIdPreafiliado = (idAfiliado) => async (
  dispatch,
  getState
) => {
  dispatch(startSpinner());
  const response = await fetchConToken(
    `Preafiliados/traerPorIdPreAfiliado/${idAfiliado}`
  );
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const afiliado = await response.json();
    // dispatch({
    //   type: types.consultaTraerAfiliadoPorCuil,
    //   payload: afiliado,
    // });
    const state = getState();
    const { idUsuario } = state.auth;
    console.log("solo nuevo");
    if (afiliado.estado > 8)
      dispatch(tomarPreAfiliacion(idUsuario, afiliado));
    else
      dispatch({
        type: types.consultaTraerAfiliadoPorCuil,
        payload: afiliado,
      });
  }

  dispatch(finishSpinner());
};
export const evaluarDocumentacionPresentadaFamiliares = (idGrupoFamiliar) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    dispatch({
      type: types.documentacionCargadaFamiliaresTraerCargadaStart,
    });
    const response = await fetchConToken(`Preafiliados/evaluarDocumentacionFamiliares/${idGrupoFamiliar}`);
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log("respuesta docu familiares", respuesta);
      if (response.status !== 200) throw respuesta.errores;
      dispatch({
        type: types.documentacionCargadaFamiliaresTraerCargadaSuccess,
        payload: respuesta,
      });
    } else {
      console.log("error de get docu", response);
      throw new Error(response);
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch({
      type: types.documentacionCargadaFamiliaresTraerCargadaError,
      payload: err.mensaje,
    });
    dispatch(startAlerta(err.mensaje, "warning", `¡Error!`))
    dispatch(finishSpinner());
  }

};
export const evaluarDocumentacionPresentadaTitular = (idGrupoFamiliar) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    dispatch({
      type: types.documentacionCargadaTitularTraerCargadaStart,
    });
    const response = await fetchConToken(`Preafiliados/evaluarDocumentacionTitular/${idGrupoFamiliar}`);
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log("respuesta docu titular", respuesta);
      if (response.status !== 200) throw respuesta.errores;
      dispatch({
        type: types.documentacionCargadaTitularTraerCargadaSuccess,
        payload: respuesta,
      });
    } else {
      console.log("error de get docu", response);
      throw new Error(response);
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch({
      type: types.documentacionCargadaTitularTraerCargadaError,
      payload: err.mensaje,
    });
    dispatch(startAlerta(err.mensaje, "warning", `¡Error!`))
    dispatch(finishSpinner());
  }

};
export const guardarAfiliadoNuevo = (data) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const state = getState();
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    const { idSeccional: idSeccionalUsuario } = state.auth;
    //console.log("data para EP", JSON.stringify(data));
    const prep = await prepareBeneficiarios(
      data,
      idAreaUsuario,
      idSeccionalUsuario
    );
    //console.log("json Prepared", JSON.stringify(prep));
    //alert('pasa');
    const response = await fetchConToken(`Preafiliados`, prep, "POST");
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      //  alert('paso 1');
      const respuesta = await response.json();
      //console.log('respuesta',respuesta);
      if (response.status !== 200) throw respuesta.errores;
      //TODO REVISAR RESPUESTA......
      dispatch({
        type: types.guardarAfiliadoNuevo,
        payload: respuesta,
      });
      dispatch(traerAfliadoPorIdPreafiliado(respuesta.idAfiliado));
    } else {
      //alert('paso 2');
      console.log("error de post precarga", response);
      throw new Error(response);
    }
    dispatch(finishSpinner());
  } catch (err) {
    //alert('paso eerror');
    dispatch(startAlerta(err.mensaje, "warning", `¡Error!`))
    dispatch(finishSpinner());
  }

};

export const guardarAfiliadoNuevoAutogestion = (data) => async (dispatch, getState) => {
  dispatch(startSpinner());
  const state = getState();
  const { usuarioAutogestion } = state.userAutogestion;
  const { afiliadoEncontrado } = state.preinscripto;

  data.url = `${urlBaseApp}/afiliaciones/AutoGestionConfirmacion/${data.cuil}`
  data.mail = data.domiciliosAfiliados.mail

  fetch(`${urlBase}/api/Autogestion`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + usuarioAutogestion.token
    }
  })
    .then(res => res.json())
    .then(res => {
      dispatch({
        type: types.guardarAfiliadoNuevo,
        payload: res,
      });
      if (afiliadoEncontrado.estado === 0) {
        dispatch(startAlerta(`Solicitud enviada`, "success", "¡Exitoso!"));
      } else {
        dispatch(startAlerta(`Informacion actualizada`, "success", "¡Exitoso!"));
      }
    })
  dispatch(finishSpinner());
};

export const guardarFamiliarNuevo = (data) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const state = getState();
    data.domiciliosAfiliados.id_afiliado = parseInt(data.domiciliosAfiliados.id_afiliado);
    data.id_tipo_afiliacion = parseInt(data.id_tipo_afiliacion);
    data.cuil = parseInt(data.cuil);
    data.nro_doc = parseInt(data.nro_doc);
    data.idGrupoFamiliar = parseInt(data.idGrupoFamiliar);
    console.log("data para EP -------", JSON.stringify(data));
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    const { idSeccional: idSeccionalUsuario } = state.auth;
    console.log("data para EP", JSON.stringify(data));
    const prep = await prepareBeneficiarios(
      data,
      idAreaUsuario,
      idSeccionalUsuario
    );
    let idFamiliar;
    const response = await fetchConToken(`Preafiliados`, prep, "POST");
    console.log("data para EP", data);
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      if (response.status !== 200) throw respuesta.errores;
      idFamiliar = respuesta.idAfiliado;
      dispatch({
        type: "guardarFamiliarAfiliadoNuevo",
        payload: respuesta,
      });
      dispatch(startAlerta(`Se agrego Familiar`, "success", "¡Exitoso!"));
      dispatch(seleccionFamiliarPreinscripto(idFamiliar));
      dispatch(fetchDocumentacionStageAfiliacion(idFamiliar));
      dispatch(fetchGrupoFamiliarPreinscripto(data.domiciliosAfiliados.id_afiliado));
      dispatch(grupoFamiliarSetTab(1));
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    dispatch(startAlerta(err.mensaje, "warning", `¡Error!`));
  }
};

export const guardarFamiliarStageFamiliarNuevo = (data) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const state = getState();
    const { consultaAfiliado } = state.afiliacion;
    data.domiciliosAfiliados.id_afiliado = parseInt(
      consultaAfiliado.domiciliosAfiliados.id_afiliado
    );
    data.id_tipo_afiliacion = parseInt(data.id_tipo_afiliacion);
    data.cuil = parseInt(data.cuil);
    data.nro_doc = parseInt(data.nro_doc);
    data.idGrupoFamiliar = parseInt(consultaAfiliado.idGrupoFamiliar);
    data.id_plan = consultaAfiliado.id_plan;
    data.id_tipo_afiliacion = consultaAfiliado.id_tipo_afiliacion;
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    const { idSeccional: idSeccionalUsuario } = state.auth;
    console.log("data para EP", JSON.stringify(data));
    const prep = await prepareBeneficiarios(
      data,
      idAreaUsuario,
      idSeccionalUsuario
    );
    let idFamiliar;
    const response = await fetchConToken(`Preafiliados/Familiar`, prep, "POST");
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      if (response.status !== 200) throw respuesta.errores;
      idFamiliar = respuesta.idAfiliado;
      dispatch(startAlerta(`Se agrego Familiar`, "success", "¡Exitoso!"));
      dispatch(seleccionFamiliarPreinscriptoStage(idFamiliar));
      dispatch(fetchDocumentacionStageFamiliarAfiliacion(idFamiliar));
      dispatch(fetchGrupoFamiliarAfiliadoPreinscriptoStage(consultaAfiliado?.idGrupoFamiliar))
      dispatch(grupoFamiliarSetTab(1));
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    console.log('error', err);
    const { mensaje } = err;
    dispatch(startAlerta(mensaje, "warning", `¡Error!`));
  }
};


export const guardarFamiliarAfiliadoNuevo = (data) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const state = getState();
    const { afiliado } = state.afiliacion;
    data.domiciliosAfiliados.id_afiliado = parseInt(
      data.domiciliosAfiliados.id_afiliado
    );
    data.id_tipo_afiliacion = parseInt(data.id_tipo_afiliacion);
    data.cuil = parseInt(data.cuil);
    data.nro_doc = parseInt(data.nro_doc);
    data.idGrupoFamiliar = parseInt(afiliado.idGrupoFamiliar);
    data.id_plan = afiliado.id_plan;
    data.id_tipo_afiliacion = afiliado.id_tipo_afiliacion;
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    const { idSeccional: idSeccionalUsuario } = state.auth;
    console.log("data para EP", JSON.stringify(data));
    const prep = await prepareBeneficiarios(
      data,
      idAreaUsuario,
      idSeccionalUsuario
    );
    let idFamiliar;
    const response = await fetchConToken(`Afiliados`, prep, "POST");
    console.log("data para EP", data);
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      if (response.status !== 200) throw respuesta.errores;
      idFamiliar = respuesta.idAfiliado;
      // dispatch({
      //   type: "guardarFamiliarAfiliadoNuevo",
      //   payload: respuesta,
      // });
      dispatch(startAlerta(`Se agrego Familiar`, "success", "¡Exitoso!"));
      dispatch(fetchDocumentacionAfiliacion(idFamiliar));
      dispatch(fetchGrupoFamiliar(afiliado?.id_afiliado))
      dispatch(seleccionFamiliarAfiliado(idFamiliar));
      dispatch(grupoFamiliarSetTab(1));
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    dispatch(startAlerta(err, "warning", `¡Error!`));
  }
};


export const desSeleccionarAfiliadoNuevo = () => async (dispatch) => {
  dispatch({
    type: types.afiliacionesAfiliadoNuevoLimpiarSeleccion,
  });
};

export const documentacionPreafiliadoChange = (payload) => {
  return {
    type: types.preafiliacionesActualizarDocumentacion,
    payload: payload,
  };
};

export const aprobarPreafiliacionFamiliarBandeja = (idAfiliado, idGrupo) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const state = getState();
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    const response = await fetchConToken(`Preafiliados/aprobarFamiliar/${idAreaUsuario}/${idAfiliado}/${idGrupo}`, {}, "PUT");
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log(respuesta);
      if (!response.ok) throw respuesta.errores;
      dispatch(agregarNotificacion(idGrupo, respuesta.estado, idAreaUsuario, respuesta.idArea, null, respuesta.id_afiliado));
      //idGrupoFamiliar, estado, idBandejaOrigen, idBandejaDestino, observacion, idAfiliado
      dispatch({
        type: "envioBandejaPreafiliado",
        payload: respuesta,
      });
      dispatch(startAlerta(`Envio Exitoso`, 'success', 'La aprobación fue realizada correctamente'));
      dispatch(finishSpinner());
    } else {
      console.log("error de post precarga", response);
    }
  } catch (err) {
    dispatch(finishSpinner());
    dispatch(startAlerta("Error al aprobar la PreAfiliacion. " + err.mensaje, "warning", `¡Error!`));
    console.log(err.mensaje);
  }
};

export const observarPreafiliacionFamiliarBandeja = (idAfiliado, idGrupo, observacion) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const state = getState();
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);

    const data = { idArea: idAreaUsuario, idAfiliado, idGrupoFamiliar: idGrupo, textoObservacion: observacion };
    const response = await fetchConToken(`Preafiliados/rechazarFamiliar`, data, "PUT");

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log(respuesta);
      if (!response.ok) throw respuesta.errores;
      dispatch(agregarNotificacion(idGrupo, respuesta.estado, idAreaUsuario, respuesta.idArea, null, respuesta.id_afiliado, observacion));
      //idGrupoFamiliar, estado, idBandejaOrigen, idBandejaDestino, observacion, idAfiliado
      dispatch({
        type: "envioBandejaPreafiliado",
        payload: respuesta,
      });
      dispatch(startAlerta(`Envio Exitoso`, 'success', 'La observación fue realizada correctamente'));
    } else {
      console.log("error de post precarga", response);
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    dispatch(startAlerta("Error al observar la PreAfiliacion", "warning", `¡Error!`));
    console.log(err.mensaje);
  }
};


export const traerAfliadoPorCuilWeb = (cuil) => async (dispatch, getState) => {
  try {
    dispatch(desSeleccionarAfiliadoNuevo());
    dispatch(startSpinner());
    dispatch(limpiarListaDocumentacionAfiliado());
    dispatch(empresasPreafiliadoLimpiar());
    dispatch(fetchAportesPreafiliado(cuil));
    const response = await fetchConToken(
      `Preafiliados/traerDesdeServicio/${cuil}`
    );

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const afiliado = await response.json();
      if (response.status !== 200) throw afiliado.errores;
      afiliado.cuil = cuil;
      // const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
      // const { idUsuario } = state.auth;
      // Si soy usuario Seccional     AREA 1
      // Dos acciones. Evaluar o crear nuevas
      // Si evaluo ,veo 10, 11, 19, 29
      // Si es nueva debe ser 0 y la guardo coo 8/9
      // Si el estado == 1 la afiliacion es online y todavia no puede modificarse

      // Si soy usuario Nacional      AREA 2
      // Solo Evaluo en estado 20, 21, 29.     Estado 30 ya son aprobadas y deberán verse en modificar solamente.
      if (afiliado.estado === estados.Preafiliacion_NuevoOnline) {
        console.log("primer entrada");
        dispatch(
          startAlerta(
            "Pre Afiliación Online. Todavia no puede modificarse.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        // idAreaUsuario === areas.Nacional &&
        afiliado.estado === estados.Preafiliacion_BandejaNacionalObservada
      ) {
        dispatch(
          startAlerta(
            "La Pre Afiliación se encuentra en revisión por Seccional. Aguarde por favor.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (afiliado.estado === estados.Preafiliacion_BandejaNacionalAprobada) {
        dispatch(
          startAlerta(
            "El cuil ingresado corresponde a un afiliado activo.",
            "success",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        (
          afiliado.estado !== estados.Preafiliacion_Inicial &&
          afiliado.estado !== estados.Preafiliacion_PresencialNuevo &&
          afiliado.estado !== estados.Preafiliacion_BandejaSeccional &&
          afiliado.estado !==
          estados.Preafiliacion_BandejaSeccionalModificada &&
          afiliado.estado !== estados.Preafiliacion_BandejaSeccionalObservada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalObservada) ||
        (
          afiliado.estado !== estados.Preafiliacion_Inicial &&
          afiliado.estado !== estados.Preafiliacion_PresencialIngresada &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacional &&
          afiliado.estado !== estados.Preafiliacion_BandejaNacionalModificada)
      ) {
        dispatch(
          startAlerta(
            "Pre Afiliación en Evaluación. Aguarde por favor.",
            "warning",
            `¡Atención!`
          )
        );
        dispatch(changeStepper(0));
      } else if (
        afiliado.estado === estados.Preafiliacion_BandejaSeccionalObservada ||
        afiliado.estado === estados.Preafiliacion_BandejaSeccionalModificada ||
        afiliado.estado === estados.Preafiliacion_BandejaSeccional ||
        afiliado.estado === estados.Preafiliacion_BandejaNacional ||
        afiliado.estado === estados.Preafiliacion_PresencialIngresada ||
        afiliado.estado === estados.Preafiliacion_BandejaNacionalModificada ||
        afiliado.estado === estados.Preafiliacion_BandejaNacionalObservada
      ) {
        dispatch(
          startAlerta("Dirigirse a bandeja por favor.", "warning", `¡Atención!`)
        );
        dispatch(changeStepper(0));
      } else {
        dispatch({
          type: types.consultaTraerAfiliadoPorCuil,
          payload: afiliado,
        });
      }
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    err.mensaje !== undefined ? dispatch(startAlerta(err.mensaje, "warning", `¡Error!`)) : dispatch(startAlerta(err.Msg, err.Type, err.Title));
    dispatch(changeStepper(0));
  }
};